import { agregarPackACarrito } from 'scripts/agregarPackCarrito';
import { agregarProductoACarrito } from 'scripts/agregarProductoCarrito';
import { agregarViandaACarrito } from 'scripts/agregarViandaCarrito';
import { quitarPackCarrito } from 'scripts/quitarPackCarrito';
import { quitarProductoCarrito } from 'scripts/quitarProductoCarrito';
import { quitarViandaCarrito } from 'scripts/quitarViandaCarrito';
import { agregarItem } from 'store/carritoSlice';

export const getMensajeBloqueoMezclaCarrito = (items = [], tipoNuevo) => {
	const tieneViandas = items.some((item) => item.tipo === 'vianda');
	const tieneProductosOPacks = items.some((item) => item.tipo === 'producto' || item.tipo === 'pack');

	if (tipoNuevo === 'vianda' && tieneProductosOPacks) {
		return 'Tu carrito ya tiene productos o packs. Finalizá esa compra o vaciá el carrito para pedir viandas.';
	}

	if ((tipoNuevo === 'producto' || tipoNuevo === 'pack') && tieneViandas) {
		return 'Tu carrito ya tiene viandas. Finalizá esa compra o vaciá el carrito para agregar productos o combos.';
	}

	return null;
};

/**
 * Agregar un producto al carrito
 */
export const handleAddToCart = async (
	producto,
	cantidad,
	selectedAdicional,
	token,
	clienteId,
	tipo,
	dispatch,
	cantidadProductosActual = null,
) => {
	let response;
	let adicional = producto.adicional;
	const descuentos = producto.descuentos || [];
	if (!adicional) {
		adicional =
			selectedAdicional ?
				producto.adicionales.filter((adicional) => adicional.id === parseInt(selectedAdicional))[0]
			:	null;
	}

	if (tipo === 'producto') {
		response = await agregarProductoACarrito(clienteId, producto.id, cantidad, adicional?.id, token);
	} else if (tipo === 'vianda') {
		response = await agregarViandaACarrito(clienteId, producto.id, cantidad, producto.viandasDiarias || 1, token);
	} else {
		// Para packs, pasar toda la información del pack incluyendo adicionales
		response = await agregarPackACarrito(clienteId, producto.id, cantidad, token, producto);
	}

	// Verificar que la respuesta contiene el pedido_id
	const pedidoId = response?.pedido_id;

	// Crear el objeto con la información del producto/pack y el pedido_id
	let itemParaCarrito;

	if (tipo === 'pack') {
		// Para packs, preservar toda la información incluyendo precioConAdicionales
		itemParaCarrito = {
			...producto,
			cantidad,
			tipo,
			pedido_id: pedidoId,
			// Preservar campos específicos de packs
			precioConAdicionales: producto.precioConAdicionales,
			productos: producto.productos, // Información de productos con adicionales seleccionados
			precio_calculado: producto.precio_calculado,
			precio_final: producto.precio_final || producto.precio_mostrar,
			ahorro: producto.ahorro,
		};
	} else {
		// Para productos individuales y viandas
		itemParaCarrito = { ...producto, cantidad, tipo, pedido_id: pedidoId, adicional, descuentos };
	}

	dispatch(agregarItem(itemParaCarrito));
	return { primerProductoAgregado: cantidadProductosActual === 0 };
};

/**
 * Quitar un producto del carrito
 */
export const handleQuitarDeCarrito = async (userId, productoId, cantidad, tipo, adicionalId, token, viandasDiarias) => {
	try {
		if (tipo === 'producto') {
			await quitarProductoCarrito(userId, productoId, cantidad, adicionalId, token);
		} else if (tipo === 'vianda') {
			await quitarViandaCarrito(userId, productoId, cantidad, viandasDiarias || 1, token);
		} else {
			await quitarPackCarrito(userId, productoId, cantidad, token);
		}
	} catch (error) {
		alert('Error al quitar producto del carrito');
	}
};
